<template>
  <div>
    <b-popover
      v-for="(data, debtorindex) in debtors"
      :key="'d-'+debtorindex"
      ref="popover"
      :target="'popover-reactive-debtor-'+data.id"
      triggers="hover"
      placement="auto"
      container="my-container"
    >
      <template #title>
        <div class="d-flex justify-content-between align-items-center">
          <span>{{ $t('DEBTIA_DEBTOR_DETAILS') }}</span>
        </div>
      </template>
      <table
        class="client-details-table"
      >
        <tr
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_USERNAME') }}</td>
          <td class="right-values item-padding">
            {{ data.username }}
          </td>
        </tr>
        <tr
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_NAME') }}</td>
          <td class="right-values item-padding">
            {{ data.name }}
          </td>
        </tr>
        <tr
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_EMAIL') }}</td>
          <td class="right-values item-padding">
            <a :href="'mailto:' + data.email">{{ data.email }}</a>
          </td>
        </tr>
        <tr
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_PHONE') }}</td>
          <td class="right-values item-padding">
            {{ data.phone ? data.phone : 'N/A' }}
          </td>
        </tr>
        <tr
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_LOGIN') }}</td>
          <td class="right-values item-padding">
            {{ data.loginStatus === '1' ? 'Allowed' : 'Not Allowed' }}
          </td>
        </tr>
        <tr
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_SELECT_CLIENT') }}</td>
          <td class="right-values item-padding">
            {{ data.client_id ? data.client_id : 'N/A' }}
          </td>
        </tr>
        <tr
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_CONTACT_PERSON') }}</td>
          <td class="right-values item-padding">
            {{ data.contact_person ? data.contact_person : 'N/A' }}
          </td>
        </tr>
        <tr
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_DEBTOR_TYPE') }}</td>
          <td class="right-values item-padding">
            {{ data.debtor_type ? data.debtor_type : 'N/A' }}
          </td>
        </tr>
        <tr
          v-if="data.debtor_type === 'person'"
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_CPR') }}</td>
          <td class="right-values item-padding">
            {{ data.cpr }}
          </td>
        </tr>
        <tr
          v-else
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_CVRCPR') }}</td>
          <td class="right-values item-padding">
            {{ data.cvr_number }}
          </td>
        </tr>
        <tr
          v-if="data.debtor_type === 'person'"
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_BIRTHDATE') }}</td>
          <td class="right-values item-padding">
            {{ data.birthdate ? data.birthdate : 'N/A' }}
          </td>
        </tr>
      </table>
      <table
        v-if="data.address"
        class="client-addressdetails-table table-border"
      >
        <tr
          class="business-item"
        >
          <td class="left-item-padding">
            <h5>{{ $t('DEBTIA_ADDRESS') }}</h5></td>
        </tr>
        <tr
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_HOUSE_NUMBER') }}</td>
          <td class="right-values item-padding">
            {{ data.address.house_number ? data.address.house_number : 'N/A' }}
          </td>
        </tr>
        <tr
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_ROAD_NAME') }}</td>
          <td class="right-values item-padding">
            {{ data.address.road_name ? data.address.road_name : 'N/A' }}
          </td>
        </tr>
        <tr
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_PLACE_NAME') }}</td>
          <td class="right-values item-padding">
            {{ data.address.place ? data.address.place : 'N/A' }}
          </td>
        </tr>
        <tr
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_ZIP_CODE') }}</td>
          <td class="right-values item-padding">
            {{ data.address.zip_code ? data.address.zip_code : 'N/A' }}
          </td>
        </tr>
        <tr
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_CITY') }}</td>
          <td class="right-values item-padding">
            {{ data.address.city ? data.address.city : 'N/A' }}
          </td>
        </tr>
        <tr
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_COUNTRY') }}</td>
          <td class="right-values item-padding">
            {{ data.address.country ? data.address.country : 'N/A' }}
          </td>
        </tr>
      </table>
      <b-button
        v-if="$ability.can(constants.action.permissionDebtorEdit, constants.resource.debtor)"
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="outline-primary"
        :to="{ name: 'debtor-view', params: { id: data.id } }"
        target="_blank"
        class="edit-client-btn"
      >
        {{ $t("DEBTIA_VIEW_MORE") }}
        <feather-icon
          icon="ExternalLinkIcon"
        />
      </b-button>
    </b-popover>
  </div>
</template>

<script>
import constants from '@/app-configs/constants'
import Ripple from 'vue-ripple-directive'
// import store from '@/store'

import {
  BButton,
  BPopover,
} from 'bootstrap-vue'

export default {
  components: {
    BButton,
    BPopover,
  },
  directives: {
    Ripple,
  },
  // setup() {
  //   const { fullCaseObject } = store.state['case-details']
  //   return {
  //     fullCaseObject,
  //   }
  // },
  props: {
    debtors: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      constants,
    }
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
// td {
//   white-space: nowrap;  /* Prevents the text from wrapping to the next line */
//   overflow: hidden;     /* Hides any overflowed content */
//   text-overflow: ellipsis; /* Displays an ellipsis (...) when the content overflows */
//   max-width: 100%;      /* Ensures the cell width doesn't exceed the container */
// }

// .right-values {
//   word-wrap: break-word; /* Allows long words to break to the next line */
//   word-break: break-all; /* Ensures the word breaks at the right position */
//   white-space: normal;   /* Allows the text to wrap inside the cell */
// }
.client-details-table,
.client-addressdetails-table {
  td { white-space: nowrap; }
  .right-values {
    word-break: break-all;
    white-space: normal;
  }
}
</style>
